import Lottie from "react-lottie";
import * as animationData from "../../../assets/animations/db.json";

interface DashboardLoaderProps {
  isVisible: boolean;
}

const DashboardLoader = (props: DashboardLoaderProps): JSX.Element | null => {
  if (!props.isVisible) return null;

  return (
    <div className="p-3 border bg-white mt-4 ">
      <Lottie options={defaultOptions} />
    </div>
  );
};

export default DashboardLoader;

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
